import React from 'react'
import { Box } from '../../Box/Box'
import { Text } from '../../Text/Text'
import { Heading } from '../../Heading/Heading'

export const DefaultContent = () => {
  return (
    <Box>
      <Heading.h3 textStyle='heading3'>Default Heading</Heading.h3>
      <Heading.h4 textStyle='heading3'>Heading4</Heading.h4>
      <Text textStyle='paragraph'>
        Paragraph. The quick brown fox jumps over the lazy dog to discover new deals every day. Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Cras id erat nec ante semper eleifend. In ex mi, eleifend non ultricies sed, ullamcorper a sem. Aenean
        mollis mi eget libero commodo, non auctor dui fermentum. Aliquam ultrices nisi in odio sodales, vel
        feugiat libero gravida.
      </Text>
      <Text textStyle='paragraph'>
        Paragraph. The quick brown fox jumps over the lazy dog to discover new deals every day. Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Cras id erat nec ante semper eleifend. In ex mi, eleifend non ultricies sed, ullamcorper a sem. Aenean
        mollis mi eget libero commodo, non auctor dui fermentum. Aliquam ultrices nisi in odio sodales, vel
        feugiat libero gravida.
      </Text>
    </Box>
  )
}
export const DefaultContent2 = () => {
  return (
    <Box m={3}>
      <Heading.h3 textStyle='heading3'>Default Heading 2</Heading.h3>
      <Heading.h4 textStyle='heading3'>Heading4</Heading.h4>
      <Text textStyle='paragraph'>
        Paragraph. The quick brown fox jumps over the lazy dog to discover new deals every day. Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Cras id erat nec ante semper eleifend. In ex mi, eleifend non ultricies sed, ullamcorper a sem. Aenean
        mollis mi eget libero commodo, non auctor dui fermentum. Aliquam ultrices nisi in odio sodales, vel
        feugiat libero gravida.
      </Text>
      <Text textStyle='paragraph'>
        Paragraph. The quick brown fox jumps over the lazy dog to discover new deals every day. Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Cras id erat nec ante semper eleifend. In ex mi, eleifend non ultricies sed, ullamcorper a sem. Aenean
        mollis mi eget libero commodo, non auctor dui fermentum. Aliquam ultrices nisi in odio sodales, vel
        feugiat libero gravida.
      </Text>
    </Box>
  )
}

export const DefaultContent3 = () => {
  return (
    <Box m={3}>
      <Heading.h3 textStyle='heading3'>Default Heading 3</Heading.h3>
      <Heading.h4 textStyle='heading3'>Heading4</Heading.h4>
      <Text textStyle='paragraph'>
        Paragraph. The quick brown fox jumps over the lazy dog to discover new deals every day. Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Cras id erat nec ante semper eleifend. In ex mi, eleifend non ultricies sed, ullamcorper a sem. Aenean
        mollis mi eget libero commodo, non auctor dui fermentum. Aliquam ultrices nisi in odio sodales, vel
        feugiat libero gravida.
      </Text>
      <Text textStyle='paragraph'>
        Paragraph. The quick brown fox jumps over the lazy dog to discover new deals every day. Lorem ipsum
        dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Cras id erat nec ante semper eleifend. In ex mi, eleifend non ultricies sed, ullamcorper a sem. Aenean
        mollis mi eget libero commodo, non auctor dui fermentum. Aliquam ultrices nisi in odio sodales, vel
        feugiat libero gravida.
      </Text>
    </Box>
  )
}
